import { Link, useLocation } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function BackLink({ title, uri, textKey }) {
	const { t } = useTranslation();
	const location = useLocation();
	const fromState = location.state?.from;

	return (
		<div className="flex items-center gap-2 text-sm text-[#666055] mb-6 flex-wrap" data-testid="horse-breadcrumb">
			{fromState ? (
				<Link to={fromState.path} className="hover:text-[#1A3C34] flex items-center gap-1 font-medium"
							data-testid="back-to-results-link">
					<ChevronLeft className="w-4 h-4" />{t('nav.back_to_results')}
					{fromState.label && <span className="text-[#666055]/70 font-normal">· {fromState.label}</span>}
				</Link>
			) : (
				<Link to={ uri } className="hover:text-[#1A3C34] flex items-center gap-1">
					<ChevronLeft className="w-4 h-4" />{t(textKey)}
				</Link>
			)}
			<span>/</span>
			<span className="text-[#1A3C34] truncate">{ title }</span>
		</div>
	);
};